import { ColumnFilter } from '../Common/ColumnFilter';

export const COLUMNS = [
	{
		Header: 'Date',
		Footer: 'Date',
		accessor: 'debit_note_date',
		Filter: ColumnFilter,
	},
	{
		Header: 'Debit Note No.',
		Footer: 'Debit Note No.',
		accessor: 'debit_note_no',
		Filter: ColumnFilter,
	},
	{
		Header: 'Supplier',
		Footer: 'Supplier',
		accessor: 'supplier_name',
		Filter: ColumnFilter,
	},
	{
		Header: 'Total Amount',
		Footer: 'Total Amount',
		accessor: 'total_amount',
		Filter: ColumnFilter,
	},
	{
		Header: 'Narration',
		Footer: 'Narration',
		accessor: 'narration',
		Filter: ColumnFilter,
	},
];

export const GROUPED_COLUMNS = [];
